import {css, StyleSheet} from 'aphrodite';
import React from 'react';

export function ChatEmptyState(): JSX.Element {
  return <div className={css(styles.emptyState)}>Type a message below to get started.</div>;
}

const styles = StyleSheet.create({
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
